import React, { useState, useEffect, useRef } from "react";
import PlusIcon from "../../assets/images/green-plus.svg";
import { Image } from "../componentIndex";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { Button } from "common/commonIndex";

const UploadDocument = ({
    handleUploadFileChange,
    documentUploadList,
    formData = {},
    buttonName,
    btnClass,
    isProfile,
    multipleFormData,
    isProfilePage,
    isCropTool, setIsCropTool,
    isquestionnaire, setSelectedImagePath, imgIcon
}) => {
    const [image, setImage] = useState(formData.answer || null); // Scoped state per instance
    const [cropData, setCropData] = useState("#");
    const [isUploadImg, setIsUploadImg] = useState(false);
    const [isCrop, setIsCrop] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const cropperRef = useRef(null);

    // Cleanup URLs when unmounting
    useEffect(() => {
        return () => {
            if (image && image instanceof Blob) {
                URL.revokeObjectURL(image);
            }
            if (cropData !== "#") {
                URL.revokeObjectURL(cropData);
            }
        };
    }, [image, cropData]);

    useEffect(() => {
        if (multipleFormData) {
            if (formData?.answer?.name) {
                const findUrl = URL.createObjectURL(formData?.answer);
                // const findUrl = URL.revokeObjectURL(formData?.answer);
                setImage(findUrl);
            } else {
                setImage(formData?.answer || null);
            }
        }
    }, [])

    useEffect(() => {
        if (isCrop) {
            setTimeout(() => {
                getCropData();
            }, 500);
        }
        if(isProfilePage){
            setIsCropTool(true);
        }
        
    }, [setIsCrop, isCrop])


    const handleImageChange = (event) => {
        const file = event?.target?.files[0];
        if (file) {
            
            setIsCrop(true);
            const objectUrl = URL.createObjectURL(file);
            setImage(objectUrl);
            handleUploadFileChange(objectUrl); // Pass the file up
            setIsUploadImg(true);
            setIsDisabled(false);
        }
    };

    const getCropData = () => {
        const cropper = cropperRef.current?.cropper;
        if (cropper) {
            if (multipleFormData) {
                cropper.getCroppedCanvas().toBlob(
                    (blob) => {
                        if (!blob) return;
                        setIsCrop(false);
                        const tempFilePath = URL.createObjectURL(blob);
                        const file = new File([blob], "cropped_image.jpg", { type: "image/jpeg" });
                        setCropData(tempFilePath);
                        setImage(tempFilePath);
                        handleUploadFileChange(file);
                        setTimeout(() => {
                            setIsDisabled(true);
                        }, 200);
                        setTimeout(() => {
                            URL.revokeObjectURL(tempFilePath);
                        }, 5000);
                    },
                    "image/jpeg"
                );
            } else {
                cropper.getCroppedCanvas().toBlob((blob) => {
                    if (blob) {
                        if (!blob) return;
                        setIsCrop(false);
                        const tempFilePath = URL.createObjectURL(blob);
                        setCropData(tempFilePath);
                        handleUploadFileChange(tempFilePath);
                        if (isquestionnaire) {
                            const file = new File([blob], "cropped_image.jpg", { type: "image/jpeg" });
                            setSelectedImagePath(file);
                        }
                        setTimeout(() => {
                            setIsDisabled(true);
                        }, 200);
                        // Revoke the URL after a delay
                        setTimeout(() => {
                            URL.revokeObjectURL(tempFilePath);
                        }, 5000);
                    }
                }, "image/jpeg");
            }
        }
    };

    return (
        <>
            <div className={`image-upload-container ${isProfile ? "col-md-6" : ""}`}>
                <input
                    type="file"
                    accept="image/*"
                    id={`file-input-${documentUploadList?.question}`}
                    onChange={handleImageChange}
                    aria-label="Upload image"
                />
                <label htmlFor={`file-input-${documentUploadList?.question}`}>
                    <div className="upload-button">
                        {documentUploadList?.question ? (
                            image || formData.answer ? (
                                <div
                                    className="doctor-photo upload-file"
                                    style={{
                                        backgroundImage: `url(${multipleFormData ? image : formData.answer ? formData.answer : image})`,
                                        backgroundSize: "cover",
                                        backgroundPosition: "center",
                                        backgroundRepeat: "no-repeat",
                                    }}
                                />
                            ) : (
                                <div>
                                    <Image imgUrl={PlusIcon} altText="plus icon" className="" />
                                    <p>{documentUploadList?.question}</p>
                                </div>
                            )
                        ) : (
                            <div className={btnClass}>
                                {imgIcon && <Image imgUrl={imgIcon} altText="plus icon" className="" />}
                                {buttonName && <p className="mb-0 name">{buttonName}</p>}
                            </div>
                        )}
                    </div>
                </label>
            </div>
            {isProfilePage ? image && isCropTool && (
                <div className={` ${isProfile ? "col-md-6 pe-0" : "d-flex align-item-center  mt-3"}`}>
                    <Cropper
                        ref={cropperRef}
                        style={{ height: isProfile ? 207 : 230, width: isProfile ? "100%" : "50%", }}
                        zoomTo={0.5}
                        initialAspectRatio={3 / 2} // Set aspect ratio to 3:2
                        preview=".img-preview"
                        src={image}
                        viewMode={1}
                        minCropBoxHeight={10}
                        minCropBoxWidth={10}
                        background={false}
                        responsive
                        autoCropArea={1}
                        checkOrientation={false}
                        guides
                        className={image ? 'isImgage' : ''}
                    />
                    {isUploadImg && (
                        <Button
                            btnClass={`btn-primary question-btn img-crop-btn ms-3 ${isProfile ? 'mt-2' : ''}`}
                            btnType={"button"}
                            btnName={"Crop"}
                            onClick={getCropData}
                            isDisabled={true}
                        />
                    )}

                </div>
            ) : image && (
                <div className={` ${isProfile ? "col-md-6" : "d-flex align-item-center  mt-3"}`}>
                    <Cropper
                        ref={cropperRef}
                        style={{ height: isProfile ? 207 : 230, width: isProfile ? "100%" : "50%", }}
                        zoomTo={0.5}
                        initialAspectRatio={3 / 2} // Set aspect ratio to 3:2
                        preview=".img-preview"
                        src={image}
                        viewMode={1}
                        minCropBoxHeight={10}
                        minCropBoxWidth={10}
                        background={false}
                        responsive
                        autoCropArea={1}
                        checkOrientation={false}
                        guides
                        className={image ? 'isImgage' : ''}
                    />
                    {isUploadImg && (
                        <Button
                            btnClass={`btn-primary question-btn img-crop-btn ms-3 ${isProfile ? 'mt-2' : ''}`}
                            btnType={"button"}
                            btnName={"Crop"}
                            onClick={getCropData}
                            isDisabled={true}
                        />
                    )}

                </div>
            ) }

        </>
    );
};

export default UploadDocument;
